import React from "react";
import { ErrorMessage } from "formik";
import "./ParticipantForm.scss";

const BirthDate = ({
    field: { name, validateField, value },
    form: { setFieldValue, setFieldTouched },
    label,
    className,
    placeholder,
    ...props
}) => (
        <div className="field">
            <label className="label" htmlFor="date">
                {label}
            </label>
            <input
                className="input"
                name={name}
                type="date"
                value={value}
                validate={validateField}
                placeholder={placeholder}
                onChange={e => {
                    setFieldTouched(name, true, true);
                    setFieldValue(name, e.target.value);
                }}
            />
            <ErrorMessage className="validation-message" name={name} component="span" />
        </div>
    );

export default BirthDate;
